module.exports = __webpack_public_path__ + "img/inv_ro.c5822187.png";